<!--
	메뉴경로 : 관리자 이미지 업로드 공통양식
 -->

<template>
	<!-- 업로드된 이미지 미리보기 -->
	<div class="text-center mb-2" style="width:100%; overflow-x:auto; white-space: nowrap;">
		<template v-for="(file, index) in files" :key="index">
			<CImage v-if="file.preview == true"
					rounded
					:src="file.filePath != null && file.filePath != '' ? file.filePath : file.previewUrl"
					v-c-tooltip="{content: file.fileNm, placement: 'top'}"
					style="width:200px;;object-fit:cover;margin-right:5px;"
					/>
		</template>
	</div>
	<!-- 업로드된 이미지 미리보기 -->

	<!-- 업로드 -->
	<CInputGroup v-for="(file, index) in files" :key="index" :id="'imageGroup_' + index" :class="[ files.length != index+1 && files.length > 1 ? 'mb-3' : '']">
		<CInputGroupText component="label" :for="'image' + componentName + '_' + index" style="cursor:pointer;">Upload</CInputGroupText>
		<CFormInput type="file"
					:id="'image' + componentName + '_' + index"
					:data-index="index"
					:data-gdsImageSn="file.gdsImageSn"
					:data-gdsIntroSn="myGdsIntroSn"
					:data-fileNm="file.fileNm"
					style="display:none;"
					@change="onInputImage"/>
		<CFormInput type="text"
					:id="'image' + componentName + '_' + index"
					:data-index="index"
					:value="file.fileNm"
					disabled/>
		<template v-if="this.addOption != false">
			<CButton v-if="files.length > 0" type="button" color="secondary" variant="outline" data-btnType="add" :data-index="index" @click="changeImagefile">추가</CButton>
			<a v-if="file.fileSn > 0 && file.fileSn != null" class="btn btn-outline-secondary" :href="file.filePath">다운로드</a>
			<CButton v-if="files.length > 0" type="button" color="secondary" variant="outline" data-btnType="remove" :data-index="index" @click="changeImagefile">삭제</CButton>
		</template>
	</CInputGroup>
	<!-- 업로드 -->
</template>

<script>
import {
	fnToString,
	fnToInt,
} from '@/common/commonScript'

export default {
	name: 'fileUpDownload',
	data() {
		return {
			files : this.imgFiles,
			filesDel : this.imgDelFiles,
			myGdsIntroSn : this.gdsIntroSn,
		}
	},
	props: ["componentName", "imgFiles", "imgDelFiles", "gdsIntroSn", "addOption"],
	methods: {
		changeImagefile: function(e){
			var target = e.target;
			var fileIndex = e.target.dataset.index;

			if( target.dataset.btntype == "add" ){
				this.files.push({});
			}else{
				if( fnToInt(this.files[fileIndex].gdsImageSn) != 0 ){
					this.filesDel.push(this.files[fileIndex].fileSn);
				}

				this.files.splice(fileIndex, 1);

				if( this.files.length == 0 ){
					this.files.push({});
				}
			}
		},
		onInputImage: function(e){console.log(e);
			let fileIndex = e.target.dataset.index;
			let myGdsIntroSn = fnToInt(this.myGdsIntroSn);
			let myGdsImageSn = fnToInt(this.files[fileIndex].gdsImageSn);

			if( fnToInt(this.files[fileIndex].gdsImageSn) != 0 ){
				this.filesDel.push(this.files[fileIndex].fileSn);
				this.files[fileIndex].fileSn = "0";
			}

			this.files[fileIndex] = e.target.files[0];
			this.files[fileIndex].previewUrl = URL.createObjectURL(e.target.files[0]);
			this.files[fileIndex].fileNm = e.target.files[0].name;
			this.files[fileIndex].preview = true;
			this.files[fileIndex].gdsIntroSn = fnToInt(myGdsIntroSn);
			this.files[fileIndex].gdsImageSn = fnToInt(myGdsImageSn);
		},
	},
	beforeCreate() {
//         console.log("beforeCreate");
    },
	created() {
		// 넘어온 files 객체가 배열이 아닐때 배열로 변환
		if( !Array.isArray(this.files) ){
			this.files = new Array();
		}

		if( this.files.length < 1 ){
			this.files.push({});
		}else{
			this.files.map((x, idx) => {
				if( fnToString(this.files[idx].fileNm) != "" ){
					x.preview = true
				}
			});
		}
	}
}
</script>
